<template>
  <span class="whitespace-pre-wrap">
    <template
      v-for="(token, index) in tokens"
      :key="index"
    >
      <strong
        v-if="token.kind === 'bold'"
        class="font-semibold"
      >{{ token.value }}</strong>
      <em
        v-else-if="token.kind === 'italic'"
        class="italic"
      >{{ token.value }}</em>
      <span
        v-else-if="token.kind === 'underline'"
        class="underline underline-offset-2"
      >{{ token.value }}</span>
      <s
        v-else-if="token.kind === 'strike'"
      >{{ token.value }}</s>
      <span
        v-else-if="token.kind === 'color'"
        :style="{ color: token.color }"
      >{{ token.value }}</span>
      <a
        v-else-if="token.kind === 'link'"
        :href="token.href"
        class="text-primary underline-offset-4 hover:underline"
        rel="noopener noreferrer"
        :target="token.href.startsWith('http') ? '_blank' : undefined"
      >{{ token.value }}</a>
      <template v-else>{{ token.value }}</template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { tokenizeInline } from '~/utils/blog/inline'

const props = defineProps<{
  text: string
}>()

const tokens = computed(() => tokenizeInline(props.text || ''))
</script>
